/**
 * Created by Languagenut on 24/10/2019.
 */

import React  from 'react';

export default class Checkbox extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            toggle:false,
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            "update":true
        });
    }

    componentDidMount(){

    }

    onChange(){

    }


    render(){
        return   <label class="b-contain">
            <span>{this.props.lable || this.props.label}</span>
            <input disabled={this.props.isDisabled} onChange={(event)=>{  event.stopPropagation(); if(this.props.onChange) this.props.onChange(event) }}  checked={this.props.checked} type="checkbox"/>
            <div class="b-input"></div>
        </label> 
    }
}